import Axios from "axios";
import { bookingUrls } from "../urls";
import router from "../../../router";
import VueNotifications from "vue-notifications";
import { activityUrls } from "../../ActivityService/urls";
import { convertHexToColor } from "@syncfusion/ej2-charts";

export default {
  get_all_streamed_bookings(context, data) {
    Axios.get(
      bookingUrls.getAllStreamedBookings + "?page=1&items=10",
      data
    ).then(function (response) {

      context.commit("GET_ALL_BOOKINGS", response.data);

    });
  },
  get_all_streamed_bookings_report(context, data) {
    Axios.get(
      bookingUrls.getAllStreamedBookingsReport + "?page=1&items=10",
      data
    ).then(function (response) {

      // context.commit("GET_ALL_BOOKINGS", response.data);
      context.commit("GET_ALL_BOOKINGS_REPORT", response.data);

      // context.commit("GET_ALL_BOOKINGS_SUM", response.bookings_total);
    });
  },

  get_more_streamed_bookings(context, page) {
    Axios.get(
      bookingUrls.getAllStreamedBookings + "?page=" + page + "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_BOOKINGS", response.data);
    });
  },
  get_all_bookings(context) {
    Axios.get(bookingUrls.getAllBookings).then(function (response) {
      context.commit("GET_ALL_BOOKINGS", response.data);
    });
  },
  get_current_day_bookings(context) {

    Axios.get(bookingUrls.getCurrentDayBookings).then(function (response) {
      context.commit("GET_CURRENT_DAY_BOOKINGS", response.data);
    });
  },
  get_all_partner_bookings(context) {
    Axios.get(bookingUrls.getAllPartnerBookings).then(function (response) {
      context.commit("GET_ALL_PARTNER_BOOKINGS", response.data);
    });
  },
  get_pending_partner_bookings(context, dates) {
    Axios.post(bookingUrls.pendingPartnerBookings, dates).then(function (response) {
      context.commit("GET_PENDING_PARTNER_BOOKINGS", response.data);
    });
  },
  get_pending_group_bookings(context, dates) {
    Axios.post(bookingUrls.pendingGroupBookings, dates).then(function (response) {
      context.commit("GET_PENDING_GROUP_BOOKINGS", response.data);
    });
  },


  
  get_my_bookings(context, identifier) {
    let email = null
    let userSessionId = null

    if (typeof identifier === 'object') {
      email = identifier.email
      userSessionId = identifier.session_id
    } else {
      email = identifier
      userSessionId = null
    }

    if (!email) {
      return Promise.reject(new Error('Email is required'))
    }

    if (!userSessionId) {
      return Promise.reject(new Error('Session ID is required'))
    }

    let url = bookingUrls.getMyBookings + encodeURIComponent(email) + "?page=1&items=10"
    url = url + '&session_id=' + encodeURIComponent(userSessionId)

    return Axios.get(url, {
      headers: {
        'X-Session-ID': userSessionId
      }
    })
      .then(function (response) {
        context.commit("GET_MY_BOOKINGS", response.data)
        return response.data
      })
      .catch(function (error) {
        console.error('Error fetching bookings:', error)
        throw error
      })
  },

  get_my_bookings_streamed(context, data) {
    let email = null
    let userSessionId = null
    const page = data.page || 1

    if (typeof data.identifier === 'object') {
      email = data.identifier.email
      userSessionId = data.identifier.session_id
    } else {
      email = data.identifier
      userSessionId = null
    }

    if (!email) {
      return Promise.reject(new Error('Email is required'))
    }

    if (!userSessionId) {
      return Promise.reject(new Error('Session ID is required'))
    }

    let url = bookingUrls.getMyBookings + encodeURIComponent(email) + "?page=" + page + "&items=10"
    url = url + '&session_id=' + encodeURIComponent(userSessionId)

    return Axios.get(url, {
      headers: {
        'X-Session-ID': userSessionId
      }
    })
      .then(function (response) {
        context.commit("GET_MORE_MY_BOOKINGS", response.data)
        return response.data
      })
      .catch(function (error) {
        console.error('Error fetching more bookings:', error)
        throw error
      })
  },

  get_my_bookings_streaming(context, data) {
    let email = null
    let userSessionId = null
    const page = data.page || 1

    if (typeof data.identifier === 'object') {
      email = data.identifier.email
      userSessionId = data.identifier.session_id
    } else {
      email = data.identifier
      userSessionId = null
    }

    if (!email) {
      return Promise.reject(new Error('Email is required'))
    }

    if (!userSessionId) {
      return Promise.reject(new Error('Session ID is required'))
    }

    let url = bookingUrls.getMyBookings + encodeURIComponent(email) + "?page=" + page + "&items=10"
    url = url + '&session_id=' + encodeURIComponent(userSessionId)

    return Axios.get(url, {
      headers: {
        'X-Session-ID': userSessionId
      }
    })
      .then(function (response) {
        context.commit("GET_MORE_MY_BOOKINGS", response.data)
        return response.data
      })
      .catch(function (error) {
        console.error('Error fetching streaming bookings:', error)
        throw error
      })
  },
  get_all_my_bookings(context, identifier) {
    let email = null
    let userSessionId = null

    if (typeof identifier === 'object') {
      email = identifier.email
      userSessionId = identifier.session_id
    } else {
      email = identifier
      userSessionId = null
    }

    if (!email) {
      return Promise.reject(new Error('Email is required'))
    }

    if (!userSessionId) {
      return Promise.reject(new Error('Session ID is required'))
    }

    let url = bookingUrls.getMyBookings + encodeURIComponent(email) + "?page=0&items=10"
    url = url + '&session_id=' + encodeURIComponent(userSessionId)

    return Axios.get(url, {
      headers: {
        'X-Session-ID': userSessionId
      }
    })
      .then(function (response) {
        context.commit("GET_MY_BOOKINGS", response.data)
        return response.data
      })
      .catch(function (error) {
        console.error('Error fetching all bookings:', error)
        throw error
      })
  },
  // In your Vuex store actions
get_my_bookings_calendar(context, payload) {
  return Axios.post(
    bookingUrls.getMyBookingsCalendar + payload.identifier,
    {
      start_date: payload.start_date,
      end_date: payload.end_date
    }
  ).then(function(response) {
    context.commit("SET_MY_BOOKINGS_CALENDAR", response.data);
    return response.data;
  }).catch(function(error) {
    console.error('Error fetching bookings calendar:', error);
    throw error;
  });
},

  get_partner_bookings(context, publicId) {
    Axios.get(
      bookingUrls.getPartnerBookings + publicId + "?page=1&items=15"
    ).then(function (response) {
      context.commit("GET_PARTNER_BOOKINGS", response.data);
    });
  },
  get_partner_bookings_streamed(context, data) {
    Axios.get(
      bookingUrls.getPartnerBookings +
      data.publicId +
      "?page=" +
      data.page +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_PARTNER_BOOKINGS", response.data);
    });
  },
  get_partner_bookings_streaming(context, data) {
    Axios.get(
      bookingUrls.getPartnerBookings +
      data.publicId +
      "?page=" +
      data.page +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_PARTNER_BOOKINGS", response.data);
    });
  },
  get_partner_bookings_streamed_all(context, data) {
    Axios.get(
      bookingUrls.getPartnerBookings +
      data.publicId +
      "?page=" +
      data.page +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_PARTNER_BOOKINGS", response.data);
    });
  },
  get_partner_checkin_today_bookings(context, publicId) {
    Axios.get(
      bookingUrls.getPartnerCheckinTodayBookings + publicId + "/check_in/today"
    ).then(function (response) {
      context.commit("GET_PARTNER_CHECKIN_TODAY_BOOKINGS", response.data);
    });
  },
  get_partner_checkout_today_bookings(context, publicId) {
    Axios.get(
      bookingUrls.getPartnerCheckoutTodayBookings +
      publicId +
      "/check_out/today"
    ).then(function (response) {
      context.commit("GET_PARTNER_CHECOUT_TODAY_BOOKINGS", response.data);
    });
  },
  send_email_payment_reminder(context, publicId) {
    Axios.get(bookingUrls.requestEmailPaymentReminder + publicId).then(function (
      response
    ) {
      context.commit("GET_PARTNER_BOOKINGS", response.data);
    });
  },
  send_email(context, data) {
    Axios.post(bookingUrls.sendBookingEmail, data).then(() => { });
  },
  get_check_in_bookings_today(context) {
    Axios.get(bookingUrls.getCheckInToday).then(function (response) {
      context.commit("GET_CHECKING_IN_TODAY", response.data);
    });
  },
  get_inspection_bookings_today(context) {
    Axios.get(bookingUrls.getInspectionBookingsToday).then(function (response) {
      context.commit("GET_INSPECTION_BOOKINGS_TODAY", response.data);
    });
  },
  get_inspected_alerted_bookings(context) {
    Axios.get(bookingUrls.getAlertedBooking + "?page=1&items=15").then(function (response) {
      context.commit("GET_INSPECTED_ALERTED_BOOKINGS", response.data);
    });
  },
  get_more_inspected_alerted_bookings(context, data) {

    Axios.get(
      bookingUrls.getAlertedBooking +
      "?page=" +
      data.page +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_INSPECTED_ALERTED_BOOKINGS", response.data);
    });
  },
  get_bookings_residency_proof(context) {
    Axios.get(bookingUrls.getBookingResidencyProof + "?page=1&items=15").then(function (response) {
      context.commit("GET_BOOKINGS_RESIDENCY_PROOF", response.data);
    });
  },
  get_more_streamed_proofs(context, page) {
    Axios.get(
      bookingUrls.getBookingResidencyProof + "?page=" + page + "&items=10"
    ).then(function (response) {
      context.commit("GET_MORE_RESIDENCY_PROOFS", response.data);
    });
  },
  get_unticketed_alert(context) {
    Axios.get(bookingUrls.getUnticketedAlertedBooking + "?page=1&items=15").then(function (response) {
      context.commit("GET_INSPECTED_UNTICKETED_ALERTED_BOOKINGS", response.data);
    });
  },
  get_more_unticketed_alert(context, data) {

    Axios.get(
      bookingUrls.getUnticketedAlertedBooking +
      "?page=" +
      data.page +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_INSPECTED_UNTICKETED_ALERTED_BOOKINGS", response.data);
    });
  },


verifyPassport(context, file) {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('passport_image', file);

        Axios.post(bookingUrls.verifyPassport, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(function(response) {
            context.commit('SET_PASSPORT_VERIFICATION', response.data);
            resolve(response.data);
        })
        .catch(function(error) {
            console.error('Passport verification error:', error);
            reject((error.response && error.response.data) || error);
        });
    });
},


verifyPassportBase64({ commit }, payload) {
    return new Promise((resolve, reject) => {
        var imageBase64 = typeof payload === 'string' ? payload : payload.image_base64;
        var sessionId = typeof payload === 'object' ? payload.session_id : localStorage.getItem("lkjhgfdsa");
        var guestKey = typeof payload === 'object' ? payload.guest_key : null;
        var guestName = typeof payload === 'object' ? payload.guest_name : null;
        var bookingId = typeof payload === 'object' ? payload.booking_id : null;
        var proof = typeof payload === 'object' ? payload.proof : null;
        var docType = typeof payload === 'object' ? payload.doc_type : 'passport';
        
        Axios.post(bookingUrls.verifyPassportBase64, {
            image_base64: imageBase64,
            session_id: sessionId,
            guest_key: guestKey,
            guest_name: guestName,
            booking_id: bookingId,
            proof: proof,
            doc_type: docType
        })
        .then(function(response) {
            commit('SET_PASSPORT_VERIFICATION', response.data);
            resolve(response.data);
        })
        .catch(function(error) {
            console.error('Passport verification error:', error);
            reject((error.response && error.response.data) || error);
        });
    });
},

clearPassportVerification(context) {
    context.commit('CLEAR_PASSPORT_VERIFICATION');
},

verifyKenyanId({ commit }, file) {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('id_image', file);

        Axios.post(bookingUrls.verifyKenyanId, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(function(response) {
            commit('SET_KENYAN_ID_VERIFICATION', response.data);
            resolve(response.data);
        })
        .catch(function(error) {
            console.error('Kenyan ID verification error:', error);
            const errorData = (error.response && error.response.data) || error;
            reject(errorData);
        });
    });
},

verifyKenyanIdBase64({ commit }, payload) {
    return new Promise((resolve, reject) => {
        var imageBase64 = typeof payload === 'string' ? payload : payload.image_base64;
        var sessionId = typeof payload === 'object' ? payload.session_id : localStorage.getItem("lkjhgfdsa");
        var guestKey = typeof payload === 'object' ? payload.guest_key : null;
        var guestName = typeof payload === 'object' ? payload.guest_name : null;
        var bookingId = typeof payload === 'object' ? payload.booking_id : null;
        var proof = typeof payload === 'object' ? payload.proof : null;
        var docType = typeof payload === 'object' ? payload.doc_type : 'kenyan_id';
        
        Axios.post(bookingUrls.verifyKenyanIdBase64, {
            image_base64: imageBase64,
            session_id: sessionId,
            guest_key: guestKey,
            guest_name: guestName,
            booking_id: bookingId,
            proof: proof,
            doc_type: docType
        })
        .then(function(response) {
            commit('SET_KENYAN_ID_VERIFICATION', response.data);
            resolve(response.data);
        })
        .catch(function(error) {
            console.error('Kenyan ID verification error:', error);
            reject((error.response && error.response.data) || error);
        });
    });
},

clearKenyanIdVerification({ commit }) {
    commit('CLEAR_KENYAN_ID_VERIFICATION');
},

verifyWorkPermit({ commit }, file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('permit_image', file);

      Axios.post(bookingUrls.verifyWorkPermit, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(function(response) {
        commit('SET_WORK_PERMIT_VERIFICATION', response.data);
        resolve(response.data);
      })
      .catch(function(error) {
        console.error('Work Permit verification error:', error);
        const errorData = (error.response && error.response.data) || error;
        reject(errorData);
      });
    });
  },

verifyWorkPermitBase64({ commit }, payload) {
    return new Promise((resolve, reject) => {
        var imageBase64 = typeof payload === 'string' ? payload : payload.image_base64;
        var sessionId = typeof payload === 'object' ? payload.session_id : localStorage.getItem("lkjhgfdsa");
        var guestKey = typeof payload === 'object' ? payload.guest_key : null;
        var guestName = typeof payload === 'object' ? payload.guest_name : null;
        var bookingId = typeof payload === 'object' ? payload.booking_id : null;
        var proof = typeof payload === 'object' ? payload.proof : null;
        var docType = typeof payload === 'object' ? payload.doc_type : 'work_permit';
        
        Axios.post(bookingUrls.verifyWorkPermitBase64, {
            image_base64: imageBase64,
            session_id: sessionId,
            guest_key: guestKey,
            guest_name: guestName,
            booking_id: bookingId,
            proof: proof,
            doc_type: docType
        })
        .then(function(response) {
            commit('SET_WORK_PERMIT_VERIFICATION', response.data);
            resolve(response.data);
        })
        .catch(function(error) {
            console.error('Work Permit verification error:', error);
            reject((error.response && error.response.data) || error);
        });
    });
},

  clearWorkPermitVerification({ commit }) {
    commit('CLEAR_WORK_PERMIT_VERIFICATION');
  },

  verifyDocumentViaQrCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      var qrUrl = typeof payload === 'string' ? payload : payload.qr_url;
      var sessionId = typeof payload === 'object' ? payload.session_id : localStorage.getItem("lkjhgfdsa");


      var guestKey = typeof payload === 'object' ? payload.guest_key : null;
      var guestName = typeof payload === 'object' ? payload.guest_name : null;
      var bookingId = typeof payload === 'object' ? payload.booking_id : null;

      Axios.post(bookingUrls.verifyDocumentViaQrCode, {
        qr_url: qrUrl,
        guest_key: guestKey,
        guest_name: guestName,
        booking_id: bookingId,
        session_id: sessionId
      })
        .then(function (response) {
          commit('SET_WORK_PERMIT_VERIFICATION', response.data);
          resolve(response.data);
        })
        .catch(function (error) {
          reject((error.response && error.response.data) || error);
        });
    });
  },
  get_check_out_bookings_today(context) {
    Axios.get(bookingUrls.getCheckOutToday).then(function (response) {
      context.commit("GET_CHECKING_OUT_TODAY", response.data);
    });
  },
  get_overstays_this_month(context) {
    Axios.get(bookingUrls.getOverStaysThisMonth).then(function (response) {
      context.commit("GET_OVERSTAYS_THIS_MONTH", response.data);
    });
  },
  check_out_dash(context, data) {
    Axios.patch(bookingUrls.checkOutBooking, data).then(() => {
      context.dispatch("get_check_out_bookings_today");
    });
  },
  overstays_dash(context, data) {
    Axios.patch(bookingUrls.checkOutBooking, data).then(() => {
      context.dispatch("get_overstays_this_month");
    });
  },
  check_date_facility_public_availability(context, data) {
  return Axios.post(bookingUrls.checkFacilityPublicAvailability, data)
    .then(function (response) {
      context.commit("GET_FACILITY_AVAILABILITY", response.data);
      return response;
    });
  },
  check_date_facility_availability(context, data) {
  return Axios.post(bookingUrls.checkFacilityAvailability, data)
    .then(function (response) {
      context.commit("GET_FACILITY_AVAILABILITY", response.data);
      return response;
    });
  },
  check_date_external_facility_public_availability(context, data) {
    Axios.post(bookingUrls.checkExternalFacilityPublicAvailability, data).then(
      function (response) {

        context.commit("GET_EXTERNAL_FACILITY_AVAILABILITY", response.data);
      }
    );
  },
  check_date_external_facility_availability(context, data) {
    Axios.post(bookingUrls.checkExternalFacilityAvailability, data)
      .then(function (response) {

        context.commit("GET_EXTERNAL_FACILITY_AVAILABILITY", response.data);
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  check_date_single_facility_availability(context, data) {
    Axios.post(bookingUrls.checkSingleFacilityAvailability, data)
      .then(function (response) {
        context.commit("GET_SINGLE_FACILITY_AVAILABILITY", response.data);
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  get_inventory_schedule(context, data) {
    Axios.post(bookingUrls.inventoryBookingSchedule, data)
      .then(function (response) {
        context.commit("GET_INVENTORY_SCHEDULE", response.data);
      })
      .catch(function () {
        // console.log(error.data)
      });
  },
  get_facility_schedule(context, data) {
    Axios.post(bookingUrls.facilityBookingSchedule, data)
      .then(function (response) {
        context.commit("GET_FACILITY_SCHEDULE", response.data);
      })
      .catch(function () {
        // console.log(error.data)
      });
  },
  remove_booked_accommodation(context, data) {
    Axios.patch(bookingUrls.removeBookedAccommodation, data).then(() => { });
  },
  remove_booked_activity(context, data) {
    Axios.patch(bookingUrls.removeBookedActivity, data).then(() => { });
  },
  booking_mpesa_request(context, data) {
    Axios.post(bookingUrls.mpesaRequest, data)
      .then(function () { })
      .catch(function () {
        // console.log(error.data)
      });
  },
  booking_bank_slip_request(context, data) {
    Axios.post(bookingUrls.bankSlipRequest, data)
      .then(function () {
        context.commit("GET_BANK_SLIP", response.data);
      })
      .catch(function () {
        // console.log(error.data)
      });
  },
  get_bookings_payment_failure(context, data) {
    Axios.get(
      bookingUrls.getPaymentFailureRequest + "?page=1&items=10",
      data
    ).then(function (response) {
      context.commit("GET_BOOKING_PAYMENT_FAILURE", response.data);
    });
  },
  get_more_bookings_payment_failure(context, data) {
    Axios.get(
      bookingUrls.getPaymentFailureRequest +
      "?page=" +
      data +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_BOOKING_PAYMENT_FAILURE", response.data);
    });
  },
  get_bookings_payments(context, data) {
    Axios.get(
      bookingUrls.getBookingPayments + "?page=1&items=10",
      data
    ).then(function (response) {
      context.commit("GET_BOOKING_PAYMENTS", response.data);
    });
  },
  get_more_bookings_payments(context, data) {

    Axios.get(
      bookingUrls.getBookingPayments +
      "?page=" +
      data +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_BOOKING_PAYMENTS", response.data);
    });
  },

  get_booking_payment_failure(context, publicId) {
    Axios.get(bookingUrls.paymentFailureRequest + publicId).then(function (response) {
      context.commit("PAYMENT_FAILURE", response.data);
    });
  },
  check_inventory_availability(context, data) {
    Axios.post(bookingUrls.checkInventoryAvailability, data)
      .then(function (response) {
        if (response.data.data[0].available_slots === 0) {
          VueNotifications.error({
            message:
              "All slots are taken for that date. Choose a different date."
          });
        }
        context.commit("GET_AVAILABILITY", response.data);
      })
      .catch(function () {
        // console.log(error.data)
      });
  },

  check_inventory_availability_public(context) {
    Axios.get(activityUrls.checkFacilityAvailabilityPublic).then(response => {
      context.commit("GET_ACTIVE_ACTIVITIES", response.data);
    });
  },
  get_checked_in_bookings(context, dates) {
    Axios.post(bookingUrls.getCheckedInBookings, dates).then(function (response) {
      context.commit("GET_CHECKED_IN_BOOKINGS", response.data);
    });
  },
  get_checked_out_bookings(context, dates) {
    Axios.post(bookingUrls.getCheckedOutBookings, dates).then(function (response) {
      context.commit("GET_CHECKED_OUT_BOOKINGS", response.data);
    });
  },
  get_confirmed_bookings(context, dates) {
    Axios.post(bookingUrls.getConfirmedBookings, dates).then(function (response) {
      context.commit("GET_CONFIRMED_BOOKINGS", response.data);
    });
  },
  get_un_confirmed_bookings(context, dates) {
    Axios.post(bookingUrls.getUnConfirmedBookings, dates).then(function (response) {
      context.commit("GET_UN_CONFIRMED_BOOKINGS", response.data);
    });
  },
  generate_custom_csv(context, data) {
    Axios.post(bookingUrls.generateCustomReport, data)
      .then(function (response) {
        window.open(response.data.url, "_blank");
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  generate_formatted_csv(context, data) {
    Axios.post(bookingUrls.generateFormatReport, data)
      .then(function (response) {
        window.open(response.data.url, "_blank");
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  generate_custom_partner_csv(context, data) {
    Axios.post(bookingUrls.generateCustomPartnerReport, data)
      .then(function (response) {
        window.open(response.data.url, "_blank");
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  confirm_booking(context, data) {
    Axios.post(bookingUrls.confirmBooking, data)
      .then(function () {
        context.dispatch("get_confirmed_bookings");
        context.dispatch("get_un_confirmed_bookings");
        router.push({
          name: data.redirect_url
        });
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
        // console.log(error.data)
      });
  },
  generate_booking_reports(context, data) {
    Axios.post(bookingUrls.generateReports, data)
      .then(function (response) {
        window.open(response.data.url, "_blank");
      })
      .catch(function (error) {
        // console.log(error)
        // console.log(error.data)
      });
  },
  fetch_gate_entry_reports(context, data) {
    Axios.post(bookingUrls.fetchGateEntryReport, data).then(function (response) {
      context.commit("GATE_ENTRY_REPORT", response);
    });
  },
  fetch_bookings_inspection_reports(context, data) {
    Axios.post(bookingUrls.fetchBookingsInspectionReport, data).then(function (response) {
      console.log("am fetching inspected data", response.data)
      context.commit("BOOKINGS_INSPECTION_REPORT", response);
    });
  },
  fetch_daily_reports(context, data) {
    Axios.post(bookingUrls.fetchDailyReport, data).then(function (response) {
      context.commit("DAILY_REPORT", response);
    });
  },
  fetch_booking_volume_reports(context, data) {
    Axios.post(bookingUrls.fetchBookingVolumeReport, data).then(function (
      response
    ) {
      context.commit("BOOKING_VOLUME_REPORT", response.data);
    });
  },
  post_checkin(context, data) {
    Axios.patch(bookingUrls.checkInBooking, data)
      .then(function (response) {
        window.open(response.data.url, "_blank");
        router.go(-3);
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
        // console.log(error.data)
      });
  },
  post_payment(context, data) {
    Axios.post(bookingUrls.postPayment, data)
      .then(function () {
        context.dispatch("get_booking", data.booking_id);
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  allocate_receipt(context, data) {
    Axios.post(bookingUrls.allocateReceipt, data)
      .then(function () {
        context.dispatch("get_all_bank_slip_data");
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  check_in_booking(context, data) {
    Axios.post(bookingUrls.checkInBooking, data)
      .then(function (response) {
        context.dispatch("get_checked_in_bookings");
        context.dispatch("get_checked_out_bookings");
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
        // console.log(error.data)
      });
  },
  check_out_booking(context, data) {
    Axios.patch(bookingUrls.checkOutBooking, data)
      .then(function () {
        context.dispatch("get_checked_in_bookings");
        context.dispatch("get_checked_out_bookings");
        router.go(-1);
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  get_bookings(context, publicId) {
    Axios.get(bookingUrls.getBookings + publicId).then(function (response) {
      context.commit("GET_BOOKINGS", response.data);
    });
  },
  get_deleted_bookings(context) {
    Axios.get(bookingUrls.getDeletedBooking).then(function (response) {
      context.commit("GET_DELETED_BOOKINGS", response.data);
    });
  },
  get_booking(context, publicId) {
    Axios.get(bookingUrls.getBooking + publicId).then(function (response) {
      context.commit("GET_BOOKING", response.data);
    });
  },
  get_booking_view_detail(context, publicId) {
    Axios.get(bookingUrls.getBookingViewDetail + publicId).then(function (response) {
      context.commit("GET_BOOKING_VIEW_DETAIL", response.data);
    });
  },
  get_booking_view_more_detail(context, publicId) {
    Axios.get(bookingUrls.getBookingViewMoreDetail + publicId).then(function (response) {
      context.commit("GET_BOOKING_VIEW_MORE_DETAIL", response.data);
    });
  },
  get_booking_checkin(context, publicId) {
    Axios.get(bookingUrls.getBookingCheckin + publicId).then(function (response) {
      context.commit("GET_BOOKING_CHECKIN", response.data);
    });
  },
  get_booking_payment(context, publicId) {
    Axios.get(bookingUrls.getBookingPayment + publicId).then(function (response) {
      context.commit("GET_BOOKING", response.data);
    });
  },
  get_single_booking_total_cost(context, publicId) {

    Axios.get(bookingUrls.getSingleBookingTotalCost + publicId).then(function (response) {
      context.commit("GET_SINGLE_BOOKING_TOTAL_COST", response.data);
    });
  },
  get_inspection_booking(context, publicId) {
    Axios.get(bookingUrls.getInspectionBooking + publicId).then(function (response) {
      context.commit("GET_INSPECTION_BOOKING", response.data);
    });
  },
  get_booking_tickets(context, publicId) {
    Axios.get(bookingUrls.getBookingTickets).then(function (response) {
      context.commit("GET_BOOKING_TICKETS", response.data);
    });
  },
  get_batchfiles_data(context) {
    Axios.get(bookingUrls.getBatchFileData).then(function (response) {
      context.commit("GET_BATCHFILE_DATA", response.data);
    });
  },
  generate_batchfile(context, data) {
    Axios.post(bookingUrls.generateBatchfile, data).then(response => {
      if (response.status === 200) {
        context.dispatch("get_batchfiles_data");
      }
    });
  },
  generate_batchfile_by_date(context, data) {
    Axios.post(bookingUrls.generateBatchfile, data).then(response => {
      if (response.status === 200) {
        context.dispatch("get_batchfiles_data");
      }
    });
  },

  generate_bnl_batchfile_by_date (context, data) {
  Axios.post(bookingUrls.generateBnlBatchfile, data).then(response => {
    if (response.status === 200) {
      context.dispatch("get_batchfiles_data");
    }
  });
  },
  generate_credit_note_batchfile_by_date(context, data) {
    Axios.post(bookingUrls.generateCreditNoteBatchfile, data).then(response => {
      if (response.status === 200) {
        context.dispatch("get_batchfiles_data");
      }
    });
  },
  get_booking_passes(context, publicId) {
    Axios.get(bookingUrls.getBookingPasses).then(function (response) {
      context.commit("GET_BOOKING_PASSES", response.data);
    });
  },
  defer_payment(context, data) {
    Axios.post(bookingUrls.deferPayment, data).then(function (response) {
      router.push({
        name: "Checkin",
        params: {
          booking_id: data.booking_id
        }
      });
      context.dispatch("get_booking", data.booking_id);
    });
  },
  defer_payment_booking(context, data) {
    Axios.post(bookingUrls.deferPayment, data).then(function (response) {
      context.dispatch("get_booking", data.booking_id);
    });
  },
  post_booking_public(context, data) {
    return Axios.post(bookingUrls.postBooking, data)  // ← just add return
      .then(function (response) {
        const bookingId = response.data.data.booking_public_id;
        const isLoggedIn = localStorage.getItem('user_name') &&
          localStorage.getItem('user_name') !== 'null' &&
          localStorage.getItem('user_name') !== '';

        localStorage.setItem('last_booking_response', JSON.stringify(response.data.data));

        if (isLoggedIn) {
          window.open("/guest-payment/" + bookingId, "_self");
        } else {
          window.open("/payment/info/" + bookingId, "_self");
        }

        return response;
      })
      .catch(function (error) {
        console.error('Booking error:', error);
        context.commit('BOOKING_ERROR', error);
        if (context.dispatch) {
          context.dispatch('handleError', error);
        }
        throw error;
      });
  },
  post_iveri_donation(context, data) {
    Axios.post(bookingUrls.postIveriBooking, data)
      .then(function (response) {
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  request_receipt(context, data) {
    Axios.post(bookingUrls.reprintReceipt, data)
      .then(function (response) {
        window.open(response.data.url, '_blank').focus()
        // window.open(response.data.url, "_blank");
      })
      .catch(function (error) {
  
      });
  },
  post_booking(context, data) {
    Axios.post(bookingUrls.postBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          router.push({
            name: "Receipt",
            params: {
              booking_id: response.data.data.booking_public_id
            }
          });
          this.$store.state.ActivityStore.chosenInventory = [];
          this.$store.state.FacilityStore.chosenFacilities = [];
          this.$store.state.FacilityStore.chosenExternalFacility = [];
          this.$store.state.FacilityStore.multi_camping_arrivals = [];

          this.$store.state.FacilityStore.camping_multi_browser_facilities = [];
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_external_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          this.$store.commit("REMOVE_ALL_BOOKING_PROOFS");
          this.$store.state.ActivityStore.bookedInventory = [];
          this.$store.state.FacilityStore.bookedFacilities = [];
          this.$store.state.ConservationFeeStore.conservation_fees_proof = [];

        }
      })
      .catch(function (error) {
        console.log(error.data);
      });
  },
  post_group_booking(context, data) {
    Axios.post(bookingUrls.postGroupBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          router.push({
            name: "Receipt",
            params: {
              booking_id: response.data.data.booking_public_id
            }
          });
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");
        }
      })
      .catch(function () {
      });
  },
  update_group_booking(context, data) {
    Axios.patch(bookingUrls.updateGroupBooking, data)
      .then(function (response) {
        if (response.status === 201 || response.status === 200) {
          router.push({
            name: "Receipt",
            params: {
              booking_id: data.booking_id
            }
          });
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");

        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  update_member_booking(context, data) {
    Axios.patch(bookingUrls.editBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          router.push({
            name: "Receipt",
            params: {
              booking_id: response.data.data.booking_public_id
            }
          });
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");

          this.$store.state.ActivityStore.bookedInventory = [];
          this.$store.state.FacilityStore.bookedFacilities = [];
        }
      })
      .catch(function () {
        // console.log(error.data)
      });
  },
  post_partner_booking(context, data) {
    Axios.post(bookingUrls.postPartnerBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          router.push({
            name: "PartnerReceipt",
            params: {
              booking_id: response.data.data.booking_public_id
            }
          });
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");

          this.$store.state.ActivityStore.bookedInventory = [];
          this.$store.state.FacilityStore.bookedFacilities = [];

        }
      })
      .catch(function () {
        // context.commit('UPDATE_ERRORS', error.data)
        // console.log(error.data)
      });
  },
  modify_partner_booking(context, data) {
    Axios.patch(bookingUrls.modifyPartnerBooking, data).then(function (
      response
    ) {
      // context.dispatch('resetForNewBooking')
      if (response.status === 200 || response.status === 201) {
        router.push({
          name: "PartnerReceipt",
          params: {
            booking_id: data.booking_id
          }
        });
        context.dispatch("resetForNewBooking");
        localStorage.setItem("vehicle_data", JSON.stringify([]));
        localStorage.setItem("conservation_data", JSON.stringify([]));
        localStorage.setItem("facility_data", JSON.stringify([]));
        localStorage.setItem("activity_data", JSON.stringify([]));
        localStorage.setItem("old_facility_data", JSON.stringify([]));
        localStorage.setItem("old_activity_data", JSON.stringify([]));
        localStorage.setItem("camping_multi_data", JSON.stringify([]));
        this.$store.commit("REMOVE_ALL_BOOKING_PROOFS");
        this.$store.commit("REMOVE_CHOSEN_FACILITIES");
        this.$store.commit("REMOVE_CHOSEN_EXTERNAL_FACILITIES");
        this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
        this.$store.commit("REMOVE_MULTI_ARRIVALS");
        context.dispatch("resetForNewBooking");

        this.$store.state.ActivityStore.bookedInventory = [];
        this.$store.state.FacilityStore.bookedFacilities = [];
      }
    });
  },
  post_express_booking(context, data) {
    Axios.post(bookingUrls.postExpressBooking, data)
      .then(function (response) {
        context.dispatch("resetForNewBooking");
        router.push({
          name: "Receipt",
          params: {
            booking_id: response.data.data.booking_public_id
          }
        });
      })
      .catch(function (error) {
        // console.log(error.data)
      });
  },
  reinstate_booking(context, data) {
    Axios.patch(bookingUrls.reinstateBooking, data)
      .then(function () {
        context.dispatch("get_booking", data.booking_id);
        router.push({
          name: "Booking",
          params: {
            booking_id: data.booking_id
          }
        });
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
        // console.log(error.data)
      });
  },
  print_receipt(context, data) {
    Axios.post(bookingUrls.printReceiptURl, data).then(function (response) {
      window.open(response.data.url, "_blank");
    });
  },
  print_receipt_new(context, data) {

    Axios.post(bookingUrls.printReceiptURlNew, data).then(function (response) {
      window.open(response.data.url, "_blank");
    });
  },
  issue_credit_note(context, data) {
    Axios.post(bookingUrls.issueCreditNote, data).then(function (response) {
      if (response.status === 201) {
        context.dispatch("get_booking", data.booking_id);
      }
    });
  },
  print_credit_note(context, data) {
    Axios.post(bookingUrls.printCreditNote, data)
      .then(function (response) {
        window.open(response.data.url, "_blank");
      })
      .catch(function (error) {
        // context.commit("UPDATE_ERRORS", error.data);
        console.log(error);
      });
  },

  edit_catering_type(context, data) {
    Axios.patch(bookingUrls.updateCateringType, data).then(function (response) {
      if (response.status === 200) {
        context.dispatch("get_booking", data.booking_id);
      }
    });
  },
  edit_activity_date(context, data) {
    Axios.patch(bookingUrls.updateActivityDate, data).then(function (response) {
      if (response.status === 200) {
        context.dispatch("get_booking", data.booking_id);
      }
    });
  },
  edit_accommodation_dates(context, data) {
    Axios.patch(bookingUrls.updateAccommodationDates, data).then(function (
      response
    ) {
      if (response.status === 200) {
        context.dispatch("get_booking", data.booking_id);
      }
    });
  },
  mark_as_foc(context, data) {
    Axios.post(bookingUrls.markAsFOC, data).then(() => {
      context.dispatch("get_booking", data.booking_id);
      router.push({
        name: "Booking",
        params: {
          booking_id: data.booking_id
        }
      });
    });
  },
  mark_as_paid(context, data) {
    Axios.post(bookingUrls.markAsPAID, data).then(() => {
      context.dispatch("get_booking", data.booking_id);
      router.push({
        name: "Booking",
        params: {
          booking_id: data.booking_id
        }
      });
    });
  },
  mark_as_confirmed(context, data) {
    Axios.post(bookingUrls.markAsCONFIRMED, data).then(() => {
      context.dispatch("get_booking", data.booking_id);
      router.push({
        name: "Booking",
        params: {
          booking_id: data.booking_id
        }
      });
    });
  },
  update_booking(context, data) {
    Axios.patch(bookingUrls.editBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          context.dispatch("get_all_bookings");
          router.push({
            name: "Booking",
            params: {
              booking_id: data.booking_id
            }
          });
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          // localStorage.setItem("chosenExternalFacilities", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_external_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_CHOSEN_EXTERNAL_FACILITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");

          this.$store.state.ActivityStore.bookedInventory = [];
          this.$store.state.FacilityStore.bookedFacilities = [];
        }
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  postpone_booking(context, data) {
    Axios.patch(bookingUrls.postponeBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          context.dispatch("get_all_bookings");
          router.push({
            name: "Booking",
            params: {
              booking_id: data.booking_id
            }
          });
          localStorage.setItem("postponed_inventory_data", JSON.stringify([]));
          localStorage.setItem("postponed_facility_data", JSON.stringify([]));
          localStorage.setItem("postponed_external_facility_data", JSON.stringify([]));
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_external_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          localStorage.setItem("postponed_facility_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");
        }
      })
      .catch(function (error) {
        context.commit("UPDATE_ERRORS", error.data);
        // console.log(error.data)
      });
  },
  postpone_partner_booking(context, data) {
    Axios.patch(bookingUrls.postponePartnertBooking, data)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          context.dispatch("get_all_bookings");
          router.push({
            name: "Booking",
            params: {
              booking_id: data.booking_id
            }
          });
          localStorage.setItem("postponed_inventory_data", JSON.stringify([]));
          localStorage.setItem("postponed_facility_data", JSON.stringify([]));
          context.dispatch("resetForNewBooking");
          localStorage.setItem("vehicle_data", JSON.stringify([]));
          localStorage.setItem("conservation_data", JSON.stringify([]));
          localStorage.setItem("facility_data", JSON.stringify([]));
          localStorage.setItem("activity_data", JSON.stringify([]));
          localStorage.setItem("old_facility_data", JSON.stringify([]));
          localStorage.setItem("old_activity_data", JSON.stringify([]));
          localStorage.setItem("camping_multi_data", JSON.stringify([]));
          localStorage.setItem("postponed_facility_data", JSON.stringify([]));
          this.$store.commit("REMOVE_CHOSEN_FACILITIES");
          this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
          this.$store.commit("REMOVE_MULTI_ARRIVALS");
        }
      })
      .catch(function (error) {
        context.commit("UPDATE_ERROrRS", error.data);
        // console.log(error.data)
      });
  },
  // delete_booking(context, data) {
  //   Axios.patch(bookingUrls.deleteBooking, data).then(function() {

  //     localStorage.setItem("postponed_inventory_data", JSON.stringify([]));
  //     localStorage.setItem("postponed_facility_data", JSON.stringify([]));
  //     // context.dispatch("resetForNewBooking");
  //     localStorage.setItem("vehicle_data", JSON.stringify([]));
  //     localStorage.setItem("conservation_data", JSON.stringify([]));
  //     localStorage.setItem("facility_data", JSON.stringify([]));
  //     localStorage.setItem("activity_data", JSON.stringify([]));
  //     localStorage.setItem("old_facility_data", JSON.stringify([]));
  //     localStorage.setItem("old_activity_data", JSON.stringify([]));
  //     localStorage.setItem("camping_multi_data", JSON.stringify([]));
  //     localStorage.setItem("postponed_facility_data", JSON.stringify([]));
  //     this.$store.commit("REMOVE_CHOSEN_FACILITIES");
  //     this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
  //     this.$store.commit("REMOVE_MULTI_ARRIVALS");

  //     router.go(-1);
  //   });
  // },
  delete_booking(context, data) {
    Axios.patch(bookingUrls.deleteBooking, data).then(function () {
      router.go(-1);
    });
  },
  updated_campsite_booking(context, data) {
    Axios.patch(bookingUrls.updateBookedCampsite, data).then(function (
      response
    ) {
      if (response.status !== 200) {
        alert(
          "We've encountered an error while updating, " +
          data.facility_name +
          "."
        );
      }
    });
  },
  restoreBooking(context, publicId) {
    Axios.get(bookingUrls.restoreBooking + publicId).then(function (response) {
      alert(response.data.message);
      context.commit("GET_ALL_BOOKINGS", response.data);
      router.push({
        name: "Module.Bookings"
      });
    });
  },
  resetForNewBooking(context) {
    context.dispatch("get_all_vehicle_fees");
    context.dispatch("get_all_conservation_fees");
    localStorage.setItem("vehicle_data", JSON.stringify([]));
    localStorage.setItem("conservation_data", JSON.stringify([]));
    localStorage.setItem("facility_data", JSON.stringify([]));
    localStorage.setItem("activity_data", JSON.stringify([]));
    localStorage.setItem("old_facility_data", JSON.stringify([]));
    localStorage.setItem("old_activity_data", JSON.stringify([]));
    localStorage.setItem("old_external_facility_data", JSON.stringify([]));
    this.$store.commit("REMOVE_CHOSEN_FACILITIES");
    this.$store.commit("REMOVE_CHOSEN_ACTIVITIES");
    this.$store.commit("REMOVE_MULTI_ARRIVALS");
    this.$store.commit("REMOVE_CHOSEN_EXTERNAL_FACILITIES");

    this.$store.state.ActivityStore.bookedInventory = [];
    this.$store.state.FacilityStore.bookedFacilities = [];
  },
  fetch_payment_gateways(context) {
    Axios.get(bookingUrls.fetchPaymentGateways).then(() => {
      context.commit("PAYMENT_GATEWAYS");
    });
  },
  get_active_booking_activities(context) {
    Axios.get(bookingUrls.getActiveActivitiesBookings).then(function (response) {
      context.commit('GET_ACTIVE_ACTIVITIES', response.data)
    })
  },
  // Ban Bookings
  post_booking_ban(context, data) {
    Axios.post(bookingUrls.postBookingsBan, data).then(function (response) {
      context.dispatch('get_all_bookings_ban')
    })
  },
  get_all_bookings_ban(context) {
    Axios.get(
      bookingUrls.getAllBookingsBan + "?page=1&items=10"
    ).then(function (response) {
      context.commit("GET_ALL_BOOKINGS_BAN", response.data);
    });
  },
  get_more_bookings_ban(context, page) {
    Axios.get(
      bookingUrls.getAllBookingsBan + "?page=" + page + "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_BOOKINGS_BAN", response.data);
    });
  },
  get_booking_ban(context, bookingBanId) {
    Axios.get(bookingUrls.getBookingBan + bookingBanId).then(function (response) {
      context.commit("GET_BOOKING_BAN", response.data);
    }).catch(function () {
      context.dispatch('loading_false')
    })

  },
get_booking_details_by_email(context, email) {
  return Axios.get(bookingUrls.getBookingDetailsByEmail + email).then(function (response) {
    context.commit('GET_BOOKING_DETAILS', response.data)
    return response.data
  }).catch(function(error) {
    console.error('Error fetching booking details by email:', error)
    throw error
  })
},
  update_booking_ban(context, data) {
    Axios.post(bookingUrls.updateBookingBan, data).then(function (response) {
      context.dispatch('get_all_bookings_ban')
      context.dispatch('loading_false')
      router.push({
        name: "BookingsBan",

      })
    })
  },
  search_booking_ban(context, data) {
    Axios.post(bookingUrls.searchBookingBan, data).then(function (response) {
      context.commit("GET_ALL_BOOKINGS_BAN", response.data);
    }).catch(function (error) {

      // console.log(error.data)
    })
  },


  // For finance statement
  get_puser_bookings(context, publicUserId) {
    Axios.get(bookingUrls.getPUserBookings + publicUserId).then(function (response) {
      context.commit("GET_PUSER_BOOKINGS", response.data);
    }).catch(function () {
      context.dispatch('loading_false')
    })

  },
  get_finance_statements(context, publicUserId) {
    Axios.get(bookingUrls.getFinanceStatements + publicUserId).then(function (response) {
      context.commit("GET_FINANCE_STATEMENT", response.data);
    }).catch(function () {
      context.dispatch('loading_false')
    })

  },
  get_all_booking_users(context) {
    Axios.get(bookingUrls.getAllBookingUsers).then(function (response) {
      context.commit('GET_ALL_BOOKING_USERS', response.data)
    })
  },



  get_all_bank_slip_data(context, data) {
    Axios.get(
      bookingUrls.getAllBankSlipData + "?page=1&items=10",
      data
    ).then(function (response) {
      context.commit("GET_BANK_SLIP_DATA", response.data);
    });
  },
  get_more_bank_slip_data(context, data) {
    Axios.get(
      bookingUrls.getAllBankSlipData +
      "?page=" +
      data +
      "&items=15"
    ).then(function (response) {
      context.commit("GET_MORE_BANK_SLIP_DATA", response.data);
    });
  },
  log_image_view(context, data) {
    Axios.post(bookingUrls.logImageView, data);
  }
};
